import React from 'react';
import PropTypes from 'prop-types';
import { FormSectionTitle, SwitchControlled } from 'bcp-material-core';
import { TextField } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import Grid from 'src/components/Common/Grid';

function UserForm({
  id,
  isUpdate,
  handleSubmit,
  register,
  errors,
  isDisabled,
  control
}) {
  const { t } = useTranslation();
  const identityReadOnly = isUpdate;

  return (
    <form id={id} onSubmit={handleSubmit} noValidate>
      <FormSectionTitle title={t('forms.titles.user')} />
      <Grid container spacing={3}>
        <Grid item sm={6} xs={12}>
          <TextField
            type="text"
            name="userName"
            label={t('labels.username')}
            inputRef={register}
            error={!!errors.userName}
            disabled={isDisabled || identityReadOnly}
            InputProps={{ readOnly: identityReadOnly }}
            autoComplete="username"
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <TextField
            type="email"
            name="email"
            label={t('labels.email')}
            inputRef={register}
            error={!!errors.email}
            disabled={isDisabled || identityReadOnly}
            InputProps={{ readOnly: identityReadOnly }}
            autoComplete="email"
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <TextField
            type="text"
            name="name"
            label={t('labels.givenName')}
            inputRef={register}
            error={!!errors.name}
            disabled={isDisabled || identityReadOnly}
            InputProps={{ readOnly: identityReadOnly }}
            autoComplete="given-name"
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <TextField
            type="text"
            name="firstSurname"
            label={t('labels.familyName_first')}
            inputRef={register}
            error={!!errors.firstSurname}
            disabled={isDisabled || identityReadOnly}
            InputProps={{ readOnly: identityReadOnly }}
            autoComplete="family-name"
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <TextField
            type="text"
            name="secondSurname"
            label={t('labels.familyName_second')}
            inputRef={register}
            error={!!errors.secondSurname}
            disabled={isDisabled || identityReadOnly}
            InputProps={{ readOnly: identityReadOnly }}
            autoComplete="family-name"
          />
        </Grid>

        <Grid item sm={6} xs={12}>
          <SwitchControlled
            name="isSuperadmin"
            label={t('labels.superuser')}
            control={control}
            disabled={isDisabled}
            color="primary"
          />
        </Grid>

        <Grid item sm={6} xs={12}>
          <SwitchControlled
            name="active"
            label={t('labels.active')}
            control={control}
            disabled={isDisabled || identityReadOnly}
            color="primary"
          />
        </Grid>
      </Grid>
    </form>
  );
}

UserForm.defaultProps = {
  id: 'user-form',
  isUpdate: false,
  isDisabled: false
};

UserForm.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isUpdate: PropTypes.bool,
  isDisabled: PropTypes.bool,
  control: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired
};

export default UserForm;
